
import { List, Item } from '@components/productDetail/PageFooter.jsx';

import LinkPopup from '@components/popups/Link';
import * as QualityContent from '@components/popups/content/QualityGuarantee';
import * as TradeInContent from '@components/popups/content/LifetimeTradeInGuarantee';
import * as CertificateContent from '@components/popups/content/GiaCertificate';

const CertificateIcon = '/images/benefit_icons/certificate.png';
const TradeInIcon = '/images/benefit_icons/trade_in.png';
const QualityIcon = '/images/benefit_icons/quality_guarantee.png';

function GiaDiamond () {
  return (
    <div>
      <p>With any GIA diamond, you also receive:</p>
      <List>
        <Item icon={CertificateIcon}>
          <strong>GIA</strong>{' '}
          <LinkPopup initialContent={CertificateContent}>Certificate</LinkPopup>
        </Item>

        <Item icon={TradeInIcon}>
          <strong>Lifetime</strong>{' '}
          <LinkPopup initialContent={TradeInContent}>
            Trade-In Agreement
          </LinkPopup>
        </Item>
        <Item icon={QualityIcon}>
          <strong>Quality Guarantee</strong>{' '}
          <LinkPopup initialContent={QualityContent}>in writing</LinkPopup>
        </Item>
      </List>
    </div>
  );
}

export default GiaDiamond;
